import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getAvailableProviderList } from "../../services/providerApi";
import ProviderDTO from "../../shared/dtos/providerDTO";
import { ListState } from "../../shared/states/listState";

const initialState: ListState<ProviderDTO> = {
  value: [],
  status: "idle",
};

type Props = {
  serviceTypeId?: number | null;
  search?: string | null;
  orderBy?: string | null;
  order?: "ASC" | "DESC" | null;
};

export const activeProviderListAsync = createAsyncThunk(
  "providers/active",
  async ({ serviceTypeId, search, orderBy, order }: Props) => {
    return getAvailableProviderList(serviceTypeId, search, orderBy, order);
  },
);

export const activeProviderListSlice = createSlice({
  name: "activeProviderList",
  initialState,
  reducers: {
    updateActiveProviderListValue: (state) => {
      state.value = [];
    },
    updateActiveProviderFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(activeProviderListAsync.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(activeProviderListAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.value = state.value = action.payload;
      })
      .addCase(activeProviderListAsync.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const { updateActiveProviderListValue, updateActiveProviderFilter } =
  activeProviderListSlice.actions;

export default activeProviderListSlice.reducer;
